import { FormlyFieldConfig } from "@ngx-formly/core";
import { Injector } from "@angular/core";
import { FieldDefinition } from "../../../../../sections/meddra/message/fieldDefinition";
import { MeddraQueryNode } from "../MeddraQueryNode";
import { EntityEnum } from "../../EntityEnum";
import { MeddraLevel } from "../../../MeddraEnum";
import { BaseNode } from "../../BaseNode";

export class SOCQueryNode extends MeddraQueryNode {
    constructor(injector: Injector, entityNode: BaseNode|null) {
    const queryFields: FormlyFieldConfig[] =  new FieldDefinition(injector).socQueryFields;

    const queryConditions: FormlyFieldConfig[] = new FieldDefinition(injector).queryConditions;
       super(injector, [], MeddraLevel.SOC, EntityEnum.soc, queryFields, queryConditions, entityNode);
    }

    
}